var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18097_32055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 73
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18097_32055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7185 49.2185C38.697 50.2395 37.4575 50.75 36 50.75C34.5425 50.75 33.303 50.2395 32.2815 49.2185C31.2605 48.197 30.75 46.9575 30.75 45.5C30.75 44.0425 31.2605 42.803 32.2815 41.7815C33.303 40.7605 34.5425 40.25 36 40.25C37.4575 40.25 38.697 40.7605 39.7185 41.7815C40.7395 42.803 41.25 44.0425 41.25 45.5C41.25 46.9575 40.7395 48.197 39.7185 49.2185Z",
    fill: "#FCBE1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9233 65C17.4273 65 16.1493 64.4703 15.0893 63.4108C14.0298 62.3507 13.5 61.0728 13.5 59.5768V31.4232C13.5 29.9272 14.0298 28.6493 15.0893 27.5893C16.1493 26.5298 17.4273 26 18.9233 26H22.5V20C22.5 16.254 23.8135 13.0675 26.4405 10.4405C29.0675 7.8135 32.254 6.5 36 6.5C39.746 6.5 42.9325 7.8135 45.5595 10.4405C48.1865 13.0675 49.5 16.254 49.5 20V26H53.0768C54.5728 26 55.8507 26.5298 56.9108 27.5893C57.9703 28.6493 58.5 29.9272 58.5 31.4232V59.5768C58.5 61.0728 57.9703 62.3507 56.9108 63.4108C55.8507 64.4703 54.5728 65 53.0768 65H18.9233ZM18.9233 60.5H53.0768C53.3463 60.5 53.5675 60.4135 53.7405 60.2405C53.9135 60.0675 54 59.8463 54 59.5768V31.4232C54 31.1537 53.9135 30.9325 53.7405 30.7595C53.5675 30.5865 53.3463 30.5 53.0768 30.5H18.9233C18.6538 30.5 18.4325 30.5865 18.2595 30.7595C18.0865 30.9325 18 31.1537 18 31.4232V59.5768C18 59.8463 18.0865 60.0675 18.2595 60.2405C18.4325 60.4135 18.6538 60.5 18.9233 60.5ZM27 26H45V20C45 17.5 44.125 15.375 42.375 13.625C40.625 11.875 38.5 11 36 11C33.5 11 31.375 11.875 29.625 13.625C27.875 15.375 27 17.5 27 20V26Z",
    fill: "#395966"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e5066e30ee40cc758c0136b7e25873d9.svg";
export { ForwardRef as ReactComponent };